import MemberSearchVue from '@/views/sic/member-search/member-search.vue';

const basePath = '/sic/member-search';
const role = 'sic'; // 角色身份

export const SIC_MEMBER_SEARCH_INDEX = 'sic-member-search-index';
export const SIC_MEMBER_SEARCH_SHOW = 'sic-member-search-show';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: MemberSearchVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: SIC_MEMBER_SEARCH_INDEX,
      component: () => import(
        /* webpackChunkName: "member search" */
        `@/views/${role}/member-search/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    {
      path: `${basePath}/show`,
      name: SIC_MEMBER_SEARCH_SHOW,
      component: () => import(
        /* webpackChunkName: "member show" */
        `@/views/${role}/member-search/show.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
